module.exports = __webpack_public_path__ + "img/vertical_6_2_7042.9fb33917.png";